var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "#D1D5DB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13672_3960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 17.1015V12.1148C9.33398 10.5815 10.5807 9.33479 12.114 9.33479H12.6673V15.3815L9.33398 17.1015ZM16.7873 9.33479H13.7807V15.4948L17.0673 18.7815H22.6673V15.2148C22.6273 15.2548 22.594 15.2948 22.5607 15.3348L21.5273 16.3415C21.014 16.8415 20.334 17.1148 19.614 17.1148C18.894 17.1148 18.214 16.8415 17.7007 16.3348L16.6807 15.3415C15.8807 14.5415 15.4473 13.4948 15.4473 12.3815C15.4473 11.2681 15.8807 10.2215 16.6673 9.43479C16.7073 9.39479 16.7473 9.36146 16.7873 9.32812V9.33479ZM16.1007 19.3881L13.1207 16.4081L9.33398 18.3481V19.8881C9.33398 21.4215 10.5807 22.6681 12.114 22.6681H13.6407L16.1007 19.3881ZM15.0273 22.6681H19.8873C21.4207 22.6681 22.6673 21.4215 22.6673 19.8881H17.114L15.034 22.6681H15.0273Z",
    fill: "#D1D5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.768 10.2293C21.1947 9.65594 20.428 9.33594 19.608 9.33594C18.788 9.33594 18.028 9.65594 17.448 10.2293C16.8747 10.8093 16.5547 11.5759 16.5547 12.3893C16.5547 13.2026 16.8747 13.9759 17.4547 14.5559L18.4747 15.5559C18.788 15.8626 19.2014 16.0159 19.608 16.0159C20.0147 16.0159 20.4347 15.8626 20.748 15.5559L21.768 14.5493C22.348 13.9759 22.668 13.2093 22.668 12.3893C22.668 11.5693 22.348 10.8093 21.768 10.2293ZM19.608 13.2226C19.148 13.2226 18.7747 12.8493 18.7747 12.3893C18.7747 11.9293 19.148 11.5559 19.608 11.5559C20.068 11.5559 20.4414 11.9293 20.4414 12.3893C20.4414 12.8493 20.068 13.2226 19.608 13.2226Z",
    fill: "#D1D5DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13672_3960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.3333,
    fill: "white",
    transform: "translate(9.33398 9.33594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapView);
export default __webpack_public_path__ + "static/media/mapView.eb83924837b0fae2cddae927da8b4acf.svg";
export { ForwardRef as ReactComponent };